import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { RestApiService } from '@core/services/rest-api.service';
import { LocalStorageItems } from '@shared/constants/local-storage-item';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarConfig } from '@shared/constants/snackbar-config';
import { switchMap, take } from 'rxjs';
import { DvSnackbarService } from '@devinco/ui/dds/snackbar';

@Component({
  selector: 'app-visma-expense',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export class VismaExpenseComponent {
  private api = inject(RestApiService);
  private router = inject(Router);
  private snackBar = inject(DvSnackbarService);
  private translate = inject(TranslateService);

  constructor() {
    const urlParams = new URLSearchParams(window.location.search);
    const vismaCode = urlParams.get('visma_code');
    const vismaState = urlParams.get('visma_state');

    if (
      vismaCode &&
      vismaState === localStorage.getItem(LocalStorageItems.VismaExpenseState)
    ) {
      localStorage.removeItem(LocalStorageItems.VismaExpenseState);
      this.api
        .postCustom(`user/SaveExternalApplicationAccess`, {
          Code: vismaCode,
        })
        .pipe(
          switchMap(() => {
            this.snackBar.open(
              this.translate.instant('General.VismaExpenseCodeSaved'),
              SnackBarConfig.Success
            );
            return this.router.navigate(['trips']);
          }),
          take(1)
        )
        .subscribe();
    } else {
      this.router.navigate(['trips']);
    }
  }
}
